import React from 'react';
import { StyleSheet, View, TouchableOpacity, ActivityIndicator } from 'react-native';

import Avatar from './Avatar';

import { Color, CommonProperties, CommonStyles, FontSize } from '../styles';
import { scale } from '../utils/scale.utils';
import BaseText from './BaseText';
import { useTranslation } from 'react-i18next';
import i18n, { useComponentTKey, i18nNS } from '../i18n';
import { Screens, Stacks } from '../constants/ScreenNames';
import { useNavigation } from '@react-navigation/native';

import { CREW_ENABLED } from '../config/env';

const ProfileHeader = ({
  isMainStackNavigator = false,
  imageURL,
  points,
  trips,
  enableExpense,
  reports,
  ...rest
}) => {
  const navigation = useNavigation();
  const { tKey } = useComponentTKey('ProfileHeader');
  const { t } = useTranslation(i18nNS.me);
  const meInfoItemNumberStyle = {
    color: Color.primary,
    fontSize: isMainStackNavigator
      ? FontSize.small + scale(4)
      : CREW_ENABLED
      ? FontSize.h1 + scale(2)
      : FontSize.h2,
    lineHeight: CREW_ENABLED ? FontSize.h1 + scale(4) : FontSize.h2 + scale(2),
    textAlign: 'center',
  };

  const meInfoItemTextStyle = {
    color: isMainStackNavigator ? Color.text.high : Color.text.low,
    lineHeight: CREW_ENABLED ? FontSize.h1 + scale(3) : FontSize.h3 + scale(4),
    fontSize: isMainStackNavigator
      ? FontSize.small + scale(2)
      : CREW_ENABLED
      ? FontSize.h1
      : FontSize.h3,
    ...(isMainStackNavigator
      ? {}
      : {
          width: scale(100),
          textAlign: 'center',
        }),
  };

  const meHeaderStyle = {
    flexDirection: 'row',
    justifyContent: CREW_ENABLED ? 'space-evenly' : 'space-around',
    alignItems: 'center',
    ...CommonProperties.pb3,
    ...(isMainStackNavigator && {
      borderBottomWidth: 1,
      borderColor: Color.formDividerColor,
      marginHorizontal: 10,
    }),
  };

  return !CREW_ENABLED ? (
    <View style={meHeaderStyle} {...rest}>
      <TouchableOpacity
        onPress={() => {
          navigation.navigate(Stacks.MytripsStack, { screen: Screens.MyTrips });
        }}
        style={CommonStyles.centerItems}
      >
        <BaseText style={meInfoItemNumberStyle}>{trips || 0}</BaseText>
        <BaseText style={meInfoItemTextStyle}>{t(tKey('Trips'))}</BaseText>
      </TouchableOpacity>
      {!isMainStackNavigator ? (
        <Avatar
          style={styles.meAvatar}
          size={scale(72)}
          source={imageURL ? { uri: imageURL } : null}
        />
      ) : (
        <></>
      )}
      {!enableExpense ? (
        <View style={CommonStyles.centerItems}>
          <BaseText style={meInfoItemNumberStyle}>{points || 0}</BaseText>
          <BaseText style={meInfoItemTextStyle}>{t(tKey('Points'))}</BaseText>
        </View>
      ) : null}
      {enableExpense ? (
        <TouchableOpacity
          onPress={() => {
            navigation.navigate(Stacks.ExpenseStack, { screen: Screens.Expense });
          }}
          style={CommonStyles.centerItems}
        >
          <BaseText style={meInfoItemNumberStyle}>{reports || 0}</BaseText>
          <BaseText style={meInfoItemTextStyle}>{t('Expenses')}</BaseText>
        </TouchableOpacity>
      ) : null}
    </View>
  ) : (
    <View style={meHeaderStyle} {...rest}>
      <Avatar
        style={styles.meAvatar}
        size={scale(72)}
        source={imageURL ? { uri: imageURL } : null}
      />
      <TouchableOpacity
        onPress={() => {
          navigation.navigate(Stacks.MytripsStack, { screen: Screens.MyTrips });
        }}
        style={styles.tripsButton}
      >
        <View style={styles.viewAllContainer}>
          {trips !== undefined ? (
            <BaseText style={meInfoItemNumberStyle}>{trips}</BaseText>
          ) : (
            <ActivityIndicator
              color={Color.primary}
              size="small"
              style={styles.loader}
            ></ActivityIndicator>
          )}
          <BaseText style={styles.meInfoItemNumberFooter}>view all</BaseText>
        </View>
        <BaseText style={meInfoItemTextStyle}>{t(tKey('Trips'))}</BaseText>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  meAvatar: {
    shadowColor: Color.black,
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
  meInfoItemNumberFooter: {
    color: Color.primary,
    ...CommonProperties.body,
    lineHeight: FontSize.body + scale(2),
    textDecorationLine: 'underline',
    textAlign: 'center',
  },
  viewAllContainer: {
    marginRight: 7,
  },
  tripsButton: {
    ...CommonStyles.centerItems,
    flexDirection: 'row',
    alignItems: 'center',
  },
  loader: {
    padding: 2,
  },
});

export default ProfileHeader;
